/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Careers_Whywedo_Love2Inputs */

const ja_careers_whywedo_love2 = /** @type {(inputs: Careers_Whywedo_Love2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ゲームに対する情熱`)
};

const en_careers_whywedo_love2 = /** @type {(inputs: Careers_Whywedo_Love2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Love for Games!`)
};

/**
* | output |
* | --- |
* | "Love for Games!" |
*
* @param {Careers_Whywedo_Love2Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const careers_whywedo_love2 = /** @type {((inputs?: Careers_Whywedo_Love2Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Careers_Whywedo_Love2Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_careers_whywedo_love2(inputs)
	return en_careers_whywedo_love2(inputs)
});
export { careers_whywedo_love2 as "careers_whyWeDo_love" }